import React, {Component} from "react";


export default class Status_404 extends Component {

    render() {
        return (
            <div className="index">
                <p>404</p>
            </div>
        );
    }
}